module.exports = __webpack_public_path__ + "static/media/photo178.29f422b7.jpg";